if (!customElements.get('card-product-swatches')) {
  customElements.define(
    'card-product-swatches',
    class CardProductSwatches extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('.card-wrapper');
        // Use global debounce (from global.js) to prevent rapid fetch requests
        this.debouncedFetch = debounce(this.fetchAndUpdate.bind(this), ON_CHANGE_DEBOUNCE_TIMER);
      }

      handleSwatchClick(button) {
        const productUrl = button.dataset.productUrl;
        if (!productUrl) return;

        // Skip if this swatch is already active
        if (button.classList.contains('active')) return;

        // 1. Update active state immediately (visual feedback)
        // this.querySelectorAll('.color-variant-item').forEach(s => s.classList.remove('active'));
        // button.classList.add('active');

        // 2. Fetch new card and swap (debounced)
        this.debouncedFetch(productUrl);
      }

      fetchAndUpdate(productUrl) {
        // Use the product-card section instead of main-product
        const url = `${productUrl}${productUrl.includes('?') ? '&' : '?'}section_id=card-product`;
        
        // Store original swatch order before fetch
        const originalSwatches = this.querySelector('.color-variants-list');
        
        fetch(url)
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newCard = doc.querySelector('.card-wrapper');
            
            if (!newCard) {
              console.warn('No .card-wrapper found in fetched HTML');
              return;
            }

            // Preserve original swatch order: replace new swatches with original
            if (originalSwatches) {
              const newSwatches = newCard.querySelector('.color-variants-list');
              if (newSwatches) {
                // Update active state on original swatches based on new product URL
                originalSwatches.querySelectorAll('.color-variant-item').forEach(swatch => {
                  swatch.classList.toggle('active', swatch.dataset.productUrl === productUrl);
                });
                // Update the "+X more" link to point to the active swatch's URL
                const moreLink = originalSwatches.querySelector('.color-variants-more');
                if (moreLink) {
                  moreLink.href = productUrl;
                }
                // Replace new swatches with original (preserving order)
                newSwatches.replaceWith(originalSwatches.cloneNode(true));
              }
            }

            // Swap the card
            this.card.replaceWith(newCard);
          })
          .catch((error) => {
            console.error('Failed to fetch product card:', error);
          });
      }
    }
  );
}

// Single delegated click handler for all card swatches
document.addEventListener('click', (e) => {
  const buttonSwatchCard = e.target.closest('card-product-swatches .color-variant-item[data-product-url]');
  if (!buttonSwatchCard) return;

  e.stopImmediatePropagation();
  
  buttonSwatchCard.closest('card-product-swatches')?.handleSwatchClick(buttonSwatchCard);
}, true);